export async function synteticDelayPromise (timeout) {
  await new Promise(((resolve) => {
    setTimeout(() => resolve(), timeout);
  }))
}